import type { ReactNode } from "react";
import styles from "./Screen.module.css";

// Экран: шапка, содержимое и полоса главного действия снизу.
export function Screen({
  header,
  children,
  action,
  direction,
  wide = false,
  hideActionOnDesktop = false,
}: {
  header?: ReactNode;
  children: ReactNode;
  action?: ReactNode;
  direction?: "miniature" | "gift";
  wide?: boolean;
  // На компьютере главное действие стоит в самой раскладке экрана, полоса снизу не нужна.
  hideActionOnDesktop?: boolean;
}) {
  const directionClass = direction === "gift" ? "gift" : direction === "miniature" ? "mini" : "";
  return (
    <div className={[styles.screen, directionClass, hideActionOnDesktop ? styles.hideActionOnDesktop : ""].join(" ")}>
      {header}
      <main className={[styles.content, wide ? styles.wide : ""].join(" ")}>{children}</main>
      {action}
    </div>
  );
}
